__webpack_require__.p = "/kr/";